<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'RadioButton',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    text: {
      type: Array as () => { key: string, text: string}[],
      required: false
    },
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    isDisabled (): boolean {
      return this.disabled;
    }
  },
  data () {
    return {
      picked: ''
    };
  },
  created () {
    this.picked = this.value;
  },
  methods: {
    pick (event: number) {
      this.picked = event.toString();
      this.$emit('change', event);
    }
  }
});
</script>

<template>
  <div >
    <div class="radio" v-for="element in text" :key="element.key" @click="pick(element.key)">
      <input
        class="radio-input"
        type="radio"
        :id="element.key"
        :value="element.key"
        v-model="picked"
      >
      <label>{{element.text}}</label>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.radio {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 24px 0;
  &-input {
    height: 20px;
    width: 20px;
    min-width: 20px;
    margin: 0 10px 0 0;
    outline: none;
  }

  label {
    color: $survey-text-color;
    font-family: $font-family;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;
  }
}
input[type="radio"]:checked {
  background-color: $primary-color;
  border-color: $primary-color;
}
input[type="radio"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: inline-block;
  padding: 2px;
  background-clip: content-box;
  border: 1px solid #989898;
  background-color: #fff;
  border-radius: 50%;
}

</style>
